import "../../components/pools/pools.css";
import { useLiquidity } from "../../hooks/useLiquidity";
import PoolListContainer from "../../components/pools/PoolListContainer";

// const Pools = () => {
//   const { getPoolsList } = useLiquidity();

//   const getPools = async () => {
//     const poolsList = await getPoolsList();
//   }

//   return (
//     <div>
//       <button onClick={getPools}>hellloo
//         {/* {address ? "Connected" : "Connect Wallet"} */}
//       </button>
//       <img src="https://github.com/CosmosContracts/junoswap-asset-list/blob/main/images/scrt.png?raw=true" alt="car" />
//     </div>
//   );
// };

const Pools = () =>{
  const { getPoolUserAmount, getPoolTotalAmount } = useLiquidity();
  const getPools = async () => {
    const {
      firstTokenAmount,
      secondTokenAmount,
      totalAmount,
    } = await getPoolTotalAmount('sJUNO-sSCRT');
    const {
      firstTokenAmountUser,
      secondTokenAmountUser,
      userAmount,
    } = await getPoolUserAmount('sJUNO-sSCRT');

    // const addRes = await doAddLiquidity(
    //   'sJUNO-SCRT',
    //   '0.025',
    //   '0.05',
    //   '0.05'
    // );
    // console.log("addRes: ", addRes);
  }
  return (
    <div className="pool-component-page component-page">
      {/* <button onClick={getPools}>hellloo
      </button> */}
      <PoolListContainer />
    </div>
  )
}

export default Pools;
